import React from "react";
import { Select } from "antd";
import { IconQuestKeyboardArrowDown } from "assets/svg";
import { QUEST_PROGRESS_TYPE_LABELS } from "common/constants";
import type { QuestProgressType } from "common/types/questManagement.type";

interface QuestProgressFilterProps {
  value: QuestProgressType;
  onChange: (value: QuestProgressType) => void;
}

const QuestProgressFilter = ({ value, onChange }: QuestProgressFilterProps) => (
  <div className="h-10 w-full sm:h-[50px] sm:max-w-[350px]">
    <Select
      aria-label="クエストフィルター"
      value={value}
      onChange={onChange}
      className="ranking-material-select h-full w-full"
      popupClassName="ranking-material-dropdown"
      suffixIcon={<IconQuestKeyboardArrowDown className="h-5 w-5" />}
      options={[
        {
          value: "monthly",
          label: `クエストフィルター：${QUEST_PROGRESS_TYPE_LABELS.monthly}`,
        },
        {
          value: "hidden",
          label: `クエストフィルター：${QUEST_PROGRESS_TYPE_LABELS.hidden}`,
        },
      ]}
    />
  </div>
);

export default QuestProgressFilter;
